<template>
  <footer class="footer">
    <div class="footer-main container">
      <div class="footer-content">
        <!-- 左侧：Logo 和简介 -->
        <div class="footer-brand">
          <img class="footer-logo" src="../assets/image/logo.svg" alt="logo" />
          <p class="footer-desc">专注电子口岸卡智慧服务平台，为进出口企业提供一站式、全流程的专业服务解决方案。</p>
          <div class="footer-contact">
            <div class="contact-item">
              <span class="icon">📞</span>
              <span>400-XXX-XXXX</span>
            </div>
            <div class="contact-item">
              <span class="icon">✉️</span>
              <span>service@icka.cn</span>
            </div>
            <div class="contact-item">
              <span class="icon">🕐</span>
              <span>工作日 9:00-18:00</span>
            </div>
          </div>
        </div>
        
        <!-- 右侧：链接列表 -->
        <div class="footer-links">
          <div class="link-column">
            <h4>制卡业务</h4>
            <ul>
              <li><a href="/product">企业新入网</a></li>
              <li><a href="/product">新增业务</a></li>
              <li><a href="/product">变更业务</a></li>
              <li><a href="/product">补办业务</a></li>
              <li><a href="/product">更新解锁</a></li>
              <li><a href="/product">安全产品</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h4>进出口权</h4>
            <ul>
              <li><a href="#">企业进出口权办理</a></li>
              <li><a href="#">海外商标注册办理</a></li>
              <li><a href="#">助力外贸出口退税</a></li>
              <li><a href="#">企业代理报关服务</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h4>帮助支持</h4>
            <ul>
              <li><a href="/material">材料下载</a></li>
              <li><a href="/faq">常见问题</a></li>
              <li><a href="/news">政策资讯</a></li>
              <li><a href="#">联系我们</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 底部版权 -->
    <div class="footer-bottom">
      <div class="footer-bottom-content container">
        <span>Copyright © 2026 电子口岸IC卡 · All Rights Reserved · 沪ICP备XXXXXXXX号-1</span>
        <div class="footer-bottom-links">
          <a href="#">隐私政策</a>
          <a href="#">服务条款</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup></script>

<style lang="scss" scoped>
.footer {
  background: #1a3a6b;
  color: rgba(255, 255, 255, 0.7);
  padding-top: 48px;

  // 覆盖全局 div/p/span/a { color: #5a5a5a } 样式
  p, span, a, div {
    color: rgba(255, 255, 255, 0.7);
  }
}

.footer-main {
  padding-top: 40px;
  padding-bottom: 32px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 48px;
}

// 品牌区域
.footer-brand {
  .footer-logo {
    height: 36px;
    filter: brightness(0) invert(1);
    opacity: 0.9;
    margin-bottom: 16px;
  }
  
  .footer-desc {
    font-size: 13px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 20px;
  }
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  .contact-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
    
    .icon {
      font-size: 14px;
    }
  }
}

// 链接区域
.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.link-column {
  h4 {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
    
    li a {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.7);
      text-decoration: none;
      transition: color 0.2s;
      
      &:hover {
        color: #F07800;
      }
    }
  }
}

// 底部版权
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px 0;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.footer-bottom-links {
  display: flex;
  gap: 20px;
  
  a {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    transition: color 0.2s;
    
    &:hover {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

// 响应式
@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  
  .footer-links {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .footer-bottom-content {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
}
</style>
